const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  updateReqtrackingat ({ state, commit, rootState }, params) {
    return rootState.axios.post('/waybilltracking/v1frontend/tno-trace/update-reqtrackingat', params)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
